export default {
      id: "small-lock-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#small-lock",
      toString: function () {
        return this.url;
      }
    }